import { useSelector, useDispatch } from 'react-redux';
import { JSONContent } from '@tiptap/react';

import { CommentPlacement, CommentType } from '@distribute/shared/types';
import { commentsModel } from '../model';
import { pagesModel } from '../../pages';
import { CommentsEditorForm } from './CommentsEditorForm';

export const CreateCommentPopup = () => {
  const dispatch = useDispatch();

  const currentPage = useSelector(
    pagesModel.selectors.selectCurrentPageWithError
  );
  const currentPageContentId = useSelector(
    pagesModel.selectors.selectCurrentContentId
  ) as number;
  const isCommentCreating = useSelector(
    commentsModel.selectors.selectIsCommentCreating
  );

  const handleSubmit = (content: JSONContent) => {
    dispatch(
      commentsModel.actions.createCommentThread({
        pageId: currentPage.id,
        contentItemId: currentPageContentId,
        contentJson: content,
        target: CommentPlacement.Editor,
        type: CommentType.Inline,
      })
    );
  };

  const handleCancel = () => {
    dispatch(commentsModel.actions.endCommentingFlow());
  };

  return (
    <div className="bg-base-white border border-gray-200 shadow-xl rounded-lg p-3 w-90">
      <CommentsEditorForm
        onCancel={handleCancel}
        onSubmit={handleSubmit}
        disabled={isCommentCreating}
      />
    </div>
  );
};
